function Art() {
  return (
    <div style={{ 
      padding: '2rem',
      minHeight: 'calc(100vh - 80px)'
    }}>
      <p style={{ fontSize: '18px', opacity: 0.8 }}>shh... coming soon</p>
    </div>
  );
}

export default Art;


